import { useTheme, Box, Typography, Link } from "@mui/material";
import { formatDate, formatMonitorType } from "./utils";
import styles from "./MonitorTimelineBody.module.css";

import PauseResumeButton from "./PauseResumeButton";
import UnEnrollButton from "./UnenrollButton";
import { APIMonitoringEnrollment } from "../../../types/APIMonitoringEnrollment";

export default function MonitorHeader({
  enrollment,
}: {
  enrollment: APIMonitoringEnrollment;
}) {
  const theme = useTheme();

  let frequencyDays: number | null = null;
  enrollment.monitors.forEach((monitor) => {
    if (monitor.is_enabled && monitor.frequency?.days) {
      if (frequencyDays === null) {
        frequencyDays = monitor.frequency.days;
      } else {
        frequencyDays = Math.max(frequencyDays, monitor.frequency.days);
      }
    }
  });

  return (
    <Box sx={{ pt: 3, pr: 4, pl: 4, pb: 4 }}>
      <Typography variant="h4" fontWeight="bold" mb={3}>
        <Link href={`//${enrollment.domain}`} target="_blank" rel="noopener">
          {enrollment.domain}
        </Link>
      </Typography>
      <Box display="flex">
        <Box
          sx={{
            flexBasis: "50%",
            display: "flex",
            flexDirection: "column",
            gap: 1.25,
          }}
        >
          {enrollment.external_ref_id && (
            <Box>
              Reference ID: <strong>{enrollment.external_ref_id}</strong>
            </Box>
          )}
          <Box>
            Next Run:{" "}
            {enrollment.next_run ? (
              <strong>{formatDate(enrollment.next_run)}</strong>
            ) : (
              "Paused"
            )}
          </Box>
          <Box>
            <div className={styles.previous}>
              Previous Run:{" "}
              {enrollment.last_run ? (
                <strong>{formatDate(enrollment.last_run)}</strong>
              ) : (
                "Never"
              )}
            </div>
          </Box>
          {frequencyDays && (
            <Box>
              Monitor Frequency: <strong>{frequencyDays} days</strong>
            </Box>
          )}
          <UnEnrollButton domain={enrollment.domain} />
        </Box>
        <Box sx={{ flexBasis: "50%" }}>
          <Box display="flex">
            <Box sx={{ flexBasis: "60%", mb: 1 }}>
              <strong>Monitored for</strong>
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
            {enrollment.monitors.map((monitor) => (
              <Box key={monitor.type} display="flex">
                <Box sx={{ flexBasis: "80%" }}>
                  <div
                    key={monitor.type}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: !monitor.is_enabled
                        ? theme.palette.grey[500]
                        : undefined,
                    }}
                  >
                    {formatMonitorType(monitor.type)}{" "}
                  </div>
                </Box>
                <Box sx={{ flexBasis: "15%" }}>
                  <PauseResumeButton
                    domain={enrollment.domain}
                    isEnabled={monitor.is_enabled}
                    monitorType={monitor.type}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
